<template>
  <div class="main text-left">
    <div class="form-floating mb-3">
      <input type="email" class="form-control" id="floatingUsername" v-model="input.username" :maxlength="50"
        :placeholder="this.$t('lang.dict.email')">
      <label for="floatingUsername">{{ this.$t('lang.dict.email') }}</label>
    </div>
    <button type="submit" class="btn btn-info" v-on:click="register()">{{ this.$t('lang.toolbar.Recovery') }}</button>
    <p>
      <br>
      <span class="fs-6 text-muted">{{ this.$t('lang.msg.toLogin') }}<span class="btn  btn-link"
          v-on:click="toLogin()">{{ this.$t('lang.toolbar.Login') }}</span></span>
    </p>
  </div>
</template>
<script>
import { Modal } from 'bootstrap'
import sx from '../../utils/core.js'

// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      input: {
        username: ''
      },
      confirmdef: {
        title: this.$t('lang.toolbar.Confirm'),
        msg: this.$t('lang.msg.toContinue'),
        okText: 'OK'
      }
    }
  },
  created() {
    this.$store.state.confirmdef = this.confirmdef
  },
  methods: {
    toLogin() {
      this.$router.replace({ name: 'Login' })
    },
    register() {
      const that = this
      if (this.input.username != '') {
        const myconfirmModal = new Modal(document.querySelector("#myModalConfirm"));
        myconfirmModal.show();
        $("#confirm").click(function () {
          myconfirmModal.hide();
          if (that.$router.currentRoute.name != "Recovery") {
            return
          }
          const mymodal = sx.showWaiting()
          var params = {
            username: that.input.username,
            token: ''
          }
          sx.request(
            that.$store.state.baseurl + '/app/account/recovery',
            params,
            function (result) {
              if (result.status === 'ok') {
                sx.hideWaiting(mymodal)
                sx.toastSuccess(result.message)
                that.$router.replace({ name: 'Login' })
              } else if (result.status === 'err') {
                sx.toastError('failed to recovery account')
              } else {
                sx.toastError('account is not exist')
              }
            },
            function (result) {
              sx.hideWaiting(mymodal)
              sx.toastError('failed to recovery account')
              console.log('recovery failed', result)
            }
          )
          sx.hideWaiting(mymodal)
        })
      } else {
        sx.toastError(that.$t('lang.error.required', { str: that.$t('lang.dict.email') }));
        console.log('username must be present')
      }
    }
  }
}
</script>
